import {
  CheckOutlined,
  CloseOutlined,
} from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { green, red } from "@mui/material/colors";

export const SUMMARY_WIDGET_THEMES = {
  amber: {
    iconColor: "#BA7517",
    iconBg: "#FAEEDA",
    labelColor: "#854F0B",
  },
  red: {
    iconColor: red[900],
    iconBg: "#FCEBEB",
    labelColor: red[900],
  },
  teal: {
    iconColor: "#1D9E75",
    iconBg: "#E1F5EE",
    labelColor: "#085041",
  },
  green: {
    iconColor: green[900],
    iconBg: "#E1F5EE",
    labelColor: "#085041",
  },
  blue: {
    iconColor: "#378ADD",
    iconBg: "#E6F1FB",
    labelColor: "#0C447C",
  },
  purple: {
    iconColor: "#534AB7",
    iconBg: "#EEEDFE",
    labelColor: "#3C3489",
  },
  coral: {
    iconColor: "#D85A30",
    iconBg: "#FAECE7",
    labelColor: "#712B13",
  },
  gray: {
    iconColor: "#888780",
    iconBg: "#F1EFE8",
    labelColor: "#5F5E5A",
  },
};

const DEFAULT_CHECKABLE_THEMES = {
  checked: "green",
  unchecked: "red",
};

const SummaryWidget = ({
  icon: Icon,
  label,
  count,
  checkedIcon,
  description,
  iconColor,
  iconBg,
  labelColor,
  onClick,
  checkedColor,
  uncheckedColor,
  checked = false,
  onToggle,
  checkable = false,
  sx,
}) => {
  const hasCustomColors = iconColor || iconBg || labelColor;

  const resolvedColors = (() => {
    if (checkable && !hasCustomColors) {
      const themeKey = checked
        ? checkedColor || DEFAULT_CHECKABLE_THEMES.checked
        : uncheckedColor || DEFAULT_CHECKABLE_THEMES.unchecked;
      return SUMMARY_WIDGET_THEMES[themeKey] || SUMMARY_WIDGET_THEMES.amber;
    }
    return {
      iconColor: iconColor || "#BA7517",
      iconBg: iconBg || "#FAEEDA",
      labelColor: labelColor || "#854F0B",
    };
  })();

  const handleClick = () => {
    if (checkable && onToggle) {
      onToggle(!checked);
    } else if (onClick) {
      onClick();
    }
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.15s ease",
        "&:hover": onClick
          ? {
              borderColor: "grey.300",
              bgcolor: "grey.50",
            }
          : {},
        ...sx,
      }}
    >
      <Box
        sx={{
          width: 36,
          height: 36,
          borderRadius: "8px",
          bgcolor: resolvedColors.iconBg,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          transition: "background-color 0.15s ease",
          svg: {
            fontSize: 18,
            color: resolvedColors.iconColor,
          },
        }}
      >
        {checkable ? (
          checked ? (
            checkedIcon ? (
              checkedIcon
            ) : (
              <CheckOutlined />
            )
          ) : (
            <CloseOutlined />
          )
        ) : (
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: 600,
              color: "text.primary",
              lineHeight: 1.2,
            }}
          >
            {count}
          </Typography>
        )}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "11px",
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: "0.04em",
            color: resolvedColors.labelColor,
            lineHeight: 1.2,
            transition: "color 0.15s ease",
          }}
        >
          {label}
        </Typography>
        {description && (
          <Typography
            sx={{
              fontSize: "11px",
              color: "text.secondary",
              lineHeight: 1.2,
              mt: 0.25,
            }}
          >
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SummaryWidget;
